// detailed work from home
export const GET_DETAILED_WFH_DATA = "GET_DETAILED_WFH_DATA"
export const GET_DETAILED_WFH_DATA_SUCCESS = "GET_DETAILED_WFH_DATA_SUCCESS"
export const GET_DETAILED_WFH_DATA_ERROR = "GEDETAILED_WFH_DATA_ERROR"

// summmary work from home
export const GET_SUMMARY_WFH_DATA = "GET_SUMMARY_WFH_DATA"
export const GET_SUMMARY_WFH_DATA_SUCCESS = "GET_SUMMARY_WFH_DATA_SUCCESS"
export const GET_SUMMARY_WFH_DATA_ERROR = "GET_SUMMARY_WFH_DATA_ERROR"

// Export DetailedWFHReport
export const EXPORT_DETAILED_WFH_DATA = "EXPORT_DETAILED_WFH_DATA"
export const EXPORT_DETAILED_WFH_DATA_SUCCESS = "EXPORT_DETAILED_WFH_DATA_SUCCESS"
export const EXPORT_DETAILED_WFH_DATA_ERROR = "EXPORT_DETAILED_WFH_DATA_ERROR"
